<script>
    import filterHelper from './filterHelper';
    export default {
        mixins: [
            filterHelper
        ],
        props: {
            categories: {
                requeired: false,
                default: null
            },
            category: {
                requeired: false,
                default: null
            },
            title: {
                requeired: false,
                default: null
            },
            max_price: {
                requeired: false,
                default: null
            },
            min_price: {
                requeired: false,
                default: null
            },
            object_type: {
                required: false,
                default: 'category'
            },
            sales: {
                required: false,
                default: false
            }
        },
        data() {
            return {
                str_names: [
                    'sort',
                    'priceMax',
                    'priceMin',
                    'page'
                ]
            }
        },
        computed: {
            get_filter: function () {
                let url = new URL(window.location.href);
                let params = url.searchParams;
                
                // Standart filter params
                let $object = {
                    priceMax: this.max_price,
                    priceMin: this.min_price,
                    sort: 'default',
                    categories: [],
                    brands: [],
                    countries: []
                };
                if (this.category && this.category.hasOwnProperty('products_attributes')) {
                    this.category.products_attributes.forEach(attr => {
                        $object[attr.slug] = [];
                    });
                }

                params.forEach( ( value, name ) => {
                    if (value.length > 0) {
                        if (!this.str_names.includes(name)) {
                        // if (value.indexOf('.') >= 0 && value.search(/\d/) != -1) {
                            let array = value.split('.');
                            let ids = [];
                            array.forEach(element => {
                                ids.push(parseInt(element));
                            });
                            $object[name] = ids;
                        } else {
                            $object[name] = value;
                        }
                    }
                });

                return $object;
            }
        },
        methods: {
            change(val) {
                this.$emit("change", this.filterNotDefaultParameters(val));
                this.setUrlParameters(val);
            },
            setUrlParameters(val) {
                let url = new URL(window.location.href);
                let params = url.searchParams;

                for (const [key, value] of Object.entries(val)) {
                    if (value.toString().length > 0 && this.filterNotDefaultParameters(val).hasOwnProperty(key) ) {
                        if (Array.isArray(value)) {
                            value.forEach((element, key) => {
                                if (element !== element) {
                                    value.splice(key, 1);
                                }
                            });
                            params.set(key, value.join('.'));
                        } else {
                            params.set(key, value);
                        }
                    } else {
                        params.delete(key);
                    }
                }
                let new_url = url.toString();
                if (window.history.replaceState) {
                    window.history.replaceState('filter', document.title, new_url);
                }
            },
            filter(val) {
                this.filter_query = val;
                this.getPaginationResults();
            },
        }
    }
</script>